












import { Component, Prop, Vue } from 'vue-property-decorator';

export interface Task {
  id: number;
  title: string;
  done: boolean;
  created?: Date;
  activated?: Date;
  fulfilled?: Date;
}

@Component({
  name: 'task'
})
export default class TaskComponent extends Vue {
  @Prop() private data!: Task;
  @Prop() private active!: boolean;

  get bus() {
    return this.$root.$data.bus;
  }

  save(updateTimestamp = false) {
    if (updateTimestamp && this.data.done) {
      this.data.fulfilled = new Date();
    }
    this.bus.$emit('save');
  }
}
